export const ADMIN_LOGIN = "ADMIN_LOGIN";
